import React, { Fragment } from "react";
import Header from "./Header";

const HeadersLayouts = ({ headerTopbar, position, onScrollToAppointment }) => {
  return (
    <Fragment>
      <Header
        headerTopbar={headerTopbar}
        position={position}
        onScrollToAppointment={onScrollToAppointment}
      />
    </Fragment>
  );
};
export default HeadersLayouts;
